<template>
	<div class="main">
		<div class="row">
			<div class="col-md-4">
				<router-link v-bind:to="'/services/' + idService" class="btn btn-info">{{ $t('Back') }}</router-link>
			</div>
			<div class="col-md-4 text-center">
				<h3>{{ $t('Requests') }}</h3>
			</div>
		</div>
		<hr />
		<div v-if="requests.length === 0" class="padding-lg text-center">
			<div class="padding-md">
				<div class="fa fa-times fa-4x text-muted"></div>
			</div>
			<h4>{{ $t('There\'s no request') }}</h4>
		</div>
		<div v-if="requests.length > 0">
			<table class="table table-striped">
				<thead>
					<tr>
						<th class="col-md-3">{{ $t('Date') }}</th>
						<th class="col-md-4">URL</th>
						<th class="col-md-2 text-center">{{ $t('Duration') }}</th>
						<th class="col-md-2 text-center">{{ $t('Status') }}</th>
						<th class="col-md-1"></th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="request of requests" v-bind:key="request.idRequest">
						<td>{{ formatDate(request.date) }}</td>
						<td>{{ request.url }}</td>
						<td class="text-center"><span v-if="request.duration">{{ request.duration }} ms</span></td>
						<td class="text-center">{{ $t(request.status || "") }}</td>
						<td class="text-right">
							<router-link v-bind:to="'/services/' + request.idService + '/requests/' + request.idRequest + '/logs'" class="btn btn-default"><span class="fa fa-search"></span></router-link>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
import moment from "moment";

export default {
	props: {
		requestsService: {
			type: Object,
		},
	},
	data() {
		return {
			idService: undefined,
			requests: [],
		};
	},
	methods: {
		formatDate(value) {
			return moment(value).format("DD/MM/YYYY HH:mm:ss");
		},
		formatJSON(value) {
			return JSON.stringify(JSON.parse(value), undefined, "   ");
		},
	},
	async created() {
		this.idService = this.$route.params.idService;
		this.requests = await this.requestsService.getRequests(this.idService);
	},
};
</script>

<style>
.main {
	padding: 30px;
}
.text-right {
	text-align: right;
}
pre {
	background-color: transparent !important;
	border: 0 !important;
	white-space: pre-wrap;
	word-wrap: break-word;
}
.request {
	height: 100px !important;
}
</style>
